import {
  defaultColumnDefinitionWithFilter,
  adminColumnDefinition,
} from '../../shared/columnDefinitions';

import config from '../../config';
import {
  EditableCheckboxCellRenderer,
  AdminCellRendererFactory,
} from '../../shared/columnDefinitions/cellRenderers';
import { dateFormatter } from '../../shared/formatters';
import {
  defaultDateCellEditor,
  defaultAgRichSelectCellEditorSelector,
} from '../../shared/columnDefinitions/cellEditor';
import {
  SelectOption,
  dataTypes,
  ONE_YEAR_IN_DAYS,
  ONE_DAY_IN_MILLISECONDS,
} from '../../shared/constants';
import dateComparator from '../../shared/americanDateComparator';

import styles from './usersMaintenance.module.scss';
import { isOwnInfo } from './utils';
import ExpireDateCellRenderer from './expireDateCellRenderer.component';

const EXPIRE_DATE_COLUMN_WIDTH = 108;

const getColumnDefinitions = ({
  onEditIconClick,
  onDeleteIconClick,
  isInEditMode,
  updateRow,
  customerData,
  expireDateEditorParams,
}) => {
  const AdminCellRenderer = AdminCellRendererFactory({
    onDeleteIconClick,
    onEditIconClick,
    shouldShowDeleteIcon: Boolean(onDeleteIconClick),
    customerData,
  });

  const onCellValueChanged = ({ data }) => updateRow(data);

  const isEditable = ({ data }) =>
    isInEditMode &&
    ((!config.isEnabledEditOwnAccount &&
      !isOwnInfo({
        rowData: data,
        customerData,
      })) ||
      config.isEnabledEditOwnAccount);

  const columnDefinitions = [
    {
      ...adminColumnDefinition,
      cellRenderer: AdminCellRenderer,
    },
    {
      ...defaultColumnDefinitionWithFilter,
      headerName: 'Role',
      field: 'roleName',
    },
    {
      ...defaultColumnDefinitionWithFilter,
      headerName: 'First Name',
      field: 'firstName',
      width: 140,
    },
    {
      ...defaultColumnDefinitionWithFilter,
      headerName: 'Last Name',
      field: 'lastName',
      width: 140,
    },
    {
      ...defaultColumnDefinitionWithFilter,
      headerName: 'Email Address',
      field: 'email',
      width: 140,
    },
    {
      ...defaultColumnDefinitionWithFilter,
      headerName: 'Created By',
      field: 'createdBy',
      width: 140,
    },
    {
      ...defaultColumnDefinitionWithFilter,
      headerName: 'Created',
      field: 'created',
      width: 140,
      comparator: dateComparator,
      valueFormatter: ({ value }) => dateFormatter(value, config.AMERICAN_DATE_TIME_FORMAT),
      comparator: dateComparator,
    },
    {
      ...defaultColumnDefinitionWithFilter,
      headerName: 'Updated By',
      field: 'updatedBy',
      width: 140,
    },
    {
      ...defaultColumnDefinitionWithFilter,
      headerName: 'Updated',
      field: 'updated',
      width: 140,
      comparator: dateComparator,
      valueFormatter: ({ value }) => dateFormatter(value, config.AMERICAN_DATE_TIME_FORMAT),
      comparator: dateComparator,
    },
    {
      ...defaultColumnDefinitionWithFilter,
      headerName: 'Last Login',
      field: 'lastLogin',
      width: 140,
      comparator: dateComparator,
      valueFormatter: ({ value }) => dateFormatter(value, config.AMERICAN_DATE_TIME_FORMAT),
      comparator: dateComparator,
    },
    {
      ...defaultColumnDefinitionWithFilter,
      headerName: 'Expires',
      field: 'expireDate',
      minWidth: EXPIRE_DATE_COLUMN_WIDTH,
      maxWidth: EXPIRE_DATE_COLUMN_WIDTH,
      suppressSizeToFit: true,
      width: 140,
      valueFormatter: ({ value }) => dateFormatter(value, config.AMERICAN_DATE_TIME_FORMAT),
      comparator: dateComparator,
      editable: isEditable,
      suppressClickEdit: true,
      cellClassRules: {
        'editable-cell': params => isEditable(params),
        [styles.redTextWrapper]: ({ value }) => !value,
      },
      cellRenderer: ExpireDateCellRenderer,
      cellRendererParams: {
        minDate: expireDateEditorParams.minDate,
        maxDate: expireDateEditorParams.maxDate,
        isDisabled: params => !isEditable(params),
        onDateChange: ({ data, expireDate }) => updateRow({ ...data, expireDate }),
      },
      onCellValueChanged,
    },
    {
      ...defaultColumnDefinitionWithFilter,
      headerName: 'Active',
      field: 'activeInd',
      width: 80,
      minWidth: 80,
      maxWidth: 80,
      suppressSizeToFit: true,
      onCellValueChanged,
      cellStyle: {
        textAlign: 'center',
      },
      cellRenderer: EditableCheckboxCellRenderer,
      cellRendererParams: {
        isDisabled: params => !isEditable(params),
      },
    },
  ];

  return columnDefinitions;
};

export default getColumnDefinitions;
